import type { Address } from '@/modules/cart/domain/Address';
import type { Cart } from '@/modules/cart/domain/Cart';
import type { CartRepository } from '@/modules/cart/domain/CartRepository';

const saveShippingAddress = (
  repository: CartRepository,
  addressPayload: Address | Omit<Address, 'id'>
): Promise<Cart> => {
  return repository.saveShippingAddress(addressPayload);
};

export default saveShippingAddress;
